<template>
    <b-card class="mb-3 request-glass-card" v-if="nonMaterialItems.length > 0">
        <b-card-header class="d-flex justify-content-between align-items-center">
            <h6 class="mb-0">Другие позиции заявки</h6>
        </b-card-header>
        <b-card-body>
            <b-table
                small
                stacked="md"
                :items="nonMaterialItems"
                :fields="itemFields"
                class="request-items-table"
            >
                <template #cell(item_name)="{ item }">
                    <EmployeeLink
                        v-if="isCatalogEmployeeItem(item)"
                        :user="getCatalogEmployeeLinkUser(item)"
                        :fallback="item.item_name || 'Сотрудник'"
                        name-order="last-first"
                    />
                    <span v-else>{{ item.item_name }}</span>
                </template>
                <template #cell(quantity)="{ item }">
                    <div v-if="canEditItems">
                        <b-form-input 
                            type="number" 
                            min="0" 
                            step="0.01" 
                            :value="item.quantity"
                            @change="onItemFieldChange(item, 'quantity', $event)" 
                            size="sm" 
                            style="max-width:140px" 
                        />
                    </div>
                    <div v-else>{{ item.quantity }}</div>
                </template>
                <template #cell(unit)="{ item }">
                    <div v-if="canEditItems">
                        <b-form-input 
                            :value="item.unit"
                            @change="onItemFieldChange(item, 'unit', $event)" 
                            size="sm"
                            style="max-width:100px" 
                        />
                    </div>
                    <div v-else>{{ item.unit }}</div>
                </template>
            </b-table>
        </b-card-body>
    </b-card>
</template>

<script>
import { mapGetters } from 'vuex';
import EmployeeLink from '@/components/EmployeeLink.vue';

/**
 * Автономный компонент позиций заявки (не материалы)
 * Отображает и позволяет редактировать другие позиции заявки
 */
export default {
    name: 'RequestItems',
    components: {
        EmployeeLink
    },
    data() {
        return {
            itemFields: [
                { key: 'item_name', label: 'Наименование' },
                { key: 'quantity', label: 'Кол-во' },
                { key: 'unit', label: 'Ед. изм.' }
            ]
        };
    },
    computed: {
        ...mapGetters('requestCard', [
            'nonMaterialItems',
            'canEditItems'
        ])
    },
    methods: {
        isCatalogEmployeeItem(item) {
            const catalogItemId = Number(item && item.catalog_item_id);
            return Boolean(
                item &&
                item.catalog_type === 'employees' &&
                Number.isInteger(catalogItemId) &&
                catalogItemId > 0 &&
                item.is_custom !== true
            );
        },
        getCatalogEmployeeLinkUser(item) {
            const catalogItemId = Number(item && item.catalog_item_id);
            return {
                user_id: catalogItemId,
                full_name: (item && item.item_name) || (catalogItemId ? `Сотрудник #${catalogItemId}` : '')
            };
        },
        onItemFieldChange(item, field, value) {
            if (field === 'quantity') {
                const numeric = Number(value);
                item[field] = isNaN(numeric) ? value : numeric;
            } else {
                item[field] = value;
            }
        }
    }
};
</script>

<style scoped>
@media (max-width: 767.98px) {
    .request-items-table >>> tbody tr {
        margin-bottom: .75rem;
        border: 1px solid #dee2e6;
        border-radius: .35rem;
        background: #fff;
        box-shadow: 0 1px 2px rgba(0, 0, 0, .04);
        overflow: hidden;
    }

    .request-items-table >>> tbody td {
        padding: .55rem .75rem;
        border-top: 1px solid #eef0f2;
    }

    .request-items-table >>> tbody td:first-child {
        border-top: 0;
    }

    .request-items-table >>> tbody td::before {
        color: #6c757d;
        font-size: .78rem;
        font-weight: 700;
        text-align: left;
    }

    .request-items-table >>> .form-control {
        width: 100%;
        max-width: none !important;
    }
}
</style>
